import { Divider } from "@material-ui/core";
import { FC, useState, useEffect } from "react";
import { AiFillBank } from "react-icons/ai";
import { FINANCIAMENTO } from "src/constants";
import { CollectionUtil } from "src/framework/commons";
import { InputMoney } from "src/framework/components/forms";
import { STATUS_CODE } from "src/framework/providers/api";
import { financiamentosPropostaProvider } from "src/providers/pagamentos/FinanciamentosPropostaProvider";
import { financiamentosProvider } from "src/providers/pagamentos/FinancimentosProvider";
import pagamentoProvider from "src/providers/pagamentos/PagamentosProvider";
import { Clientes, FinanceiraType, FinanciamentoParcela, FinanciamentoProposta, FinanciamentoSimulacao, PedidoPagamento, PedidoType, TiposPagamentoIDType } from "src/types";
import { DADOS_DEFAULT } from "../../financiamento/constants";
import { Financeiras } from "../../financiamento/Financeiras";
import { HeaderFormaPagamento } from "../HeaderFormaPagamento";

import "./styles.scss";

export interface FinanciamentoSoloProperties {
    onConfirmar: (pagamento: PedidoPagamento, tipoPagamento: TiposPagamentoIDType) => void;
    pedido: PedidoType | null;
}

const FinanciamentoSolo: FC<FinanciamentoSoloProperties> = ({
    onConfirmar,
    pedido
}) => {
    /** States e propriedades **/
    const [dados, setDados] = useState<FinanciamentoProposta | null>(null);
    const [dadosCliente, setDadosCliente] = useState<Clientes | null>(null);
    const [valorResidual, setValorResidual] = useState<number | null>(null);

    /** Métodos **/
    const getDadosCliente = async (): Promise<void> => {
        const response = await pagamentoProvider.obtemClientePedido(String(pedido?.codigo_venda))

        if (response.statusCode === STATUS_CODE.OK) {
            setDadosCliente(response?.data || null);
        }
    }

    const getDados = async (): Promise<void> => {
        try {
            const response = await financiamentosProvider.findByKey("pagamento_id", pedido?.pagamento_id)

            if (response.statusCode === STATUS_CODE.OK) {
                const _data = response?.data?.rows?.current() || response?.data

                if (_data) {
                    setDados(_data)
                }
            }
        } catch (error) {

        }
    }

    const salvar = async (): Promise<void> => {
        try {
            const id = dados?.id
            delete dados?.id;
            const response = await financiamentosPropostaProvider.save(id, dados);

            if (response.statusCode === STATUS_CODE.OK) {

            }
        } catch (error) {
            console.log("Error", error)
        }

    }

    const init = async (): Promise<void> => {
        Promise.all([
            getDadosCliente(),
            getDados(),
        ]);
    }


    /** Effects **/
    useEffect(() => {
        setDados({ ...DADOS_DEFAULT });
        setValorResidual(Number(pedido?.valor_pagamento))
        init();
    }, [])

    return <div className="FinanciamentoSolo">
        <HeaderFormaPagamento 
            icon={<><AiFillBank /></>}
            title={<>Financiamento via plataforma</>}
            subTitle={<>Faça a simulação de financiamento</>}
        />

        <div className="X12 S6 M4">
            <InputMoney 
                label="Valor a financiar"
                value={valorResidual}
                disabled={true}
                // onChangeValue={(newValue) => {
                //     const _valor = Number(newValue?.numberValue);
                //     setValorResidual(_valor)
                // }}
            />
            {/* <div className="valor-financiado-container">
                <div className="title">Valor a financiar</div>
                <div className="valor">
                    {Formater.toString(Number(pedido?.valor_pagamento), TypeRecords.CURRENCY)}</div>
                <Divider />
            </div> */}
        </div>

        <Financeiras
            solo
            pedido={pedido}
            disabledConfirmar={false}
            dadosCiente={dadosCliente}
            onChange={(simulacao: FinanciamentoSimulacao | null, financeira: FinanceiraType | null, parcela: FinanciamentoParcela | null) => {
                if (simulacao && pedido && financeira && parcela) {
                    const pedidoPagamento: PedidoPagamento = {

                        forma_pagamento: FINANCIAMENTO.id,
                        pedido: pedido.id,
                        itens: {
                            financiamento: [{
                                financeira: financeira.id,
                                simulacao: simulacao.simulacao_id,
                                valor: pedido.valor_pendente,
                                valor_original: pedido.valor_pendente,
                                valor_parcela: Number(parcela?.valor_parcela),
                                valor_entrada: Number(parcela?.valor_entrada),
                                parcelas: Number(parcela?.parcela),
                                taxa: Number(parcela?.taxa_juros),
                                carencia: Number(parcela?.dias_carencia_primeiro_pagamento),
                            }]
                        }
                    }
                    onConfirmar(pedidoPagamento, FINANCIAMENTO.id as any)
                }

            }}
        />


    </div>
}

export { FinanciamentoSolo }